import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private canRoute = false;

    constructor(private helpersService: HelpersService) {}

    canActivate(): boolean {
        return this.isLogged();
    }

    private isLogged(): boolean {
        if (this.helpersService.storageAccessToken) {
            this.canRoute = true;
        } else {
            this.canRoute = false;
            const msg = this.helpersService.instant('error-access-denied');
            this.helpersService.showToast(msg, 'danger', '/backoffice/home');
        }
        return this.canRoute;
    }
}
